import { ProductCharacteristic } from "@/@types";
import { useState } from "react";
import { snakeColumns } from "@/helpers/general";

type UnitType = "EE.UU" | "MÉTRICAS";

type ProductProps = {
    features: ProductCharacteristic[];
    activeUnit: UnitType;

};

export default function ProductTabSpec({ features, activeUnit }: ProductProps) {               
    const selectedType = activeUnit === "EE.UU" ? "English" : "Metric";

    const listMatchingUnit = features.filter(
    (f) => f.measurement_type_name === selectedType
    );

    const listNoUnit = features.filter(
    (f) => f.measurement_type_name == null
    );
    const sortedByUnit = [...listMatchingUnit, ...listNoUnit];
    const sortByRubro = (items: ProductCharacteristic[]) => {
        const groups: Record<string, ProductCharacteristic[]> = {};

        for (const item of items) {            
            if (!groups[item.rubro]) {
                groups[item.rubro] = [];
            }
            groups[item.rubro].push(item);
        }

        return Object.entries(groups).map(([rubro, content]) => ({
            rubro,
            content: snakeColumns(content)
        }));
    };
    
    const sortedFeatures =   sortByRubro(sortedByUnit);

    return (
        <ul className="grid grid-cols-1 text-sm text-gray-600">
            {sortedFeatures.map((value, index) => (
                <li
                    key={index}
                    className="border-b bg-light00"
                >
                    {/* Header */}
                    <div className="w-full flex justify-between items-center pl-4 pr-4 py-3">
                        <span className="font-bold text-gray-900 uppercase">
                            {value.rubro}
                        </span>
                    </div>

                    {/* Content */}
                    <div className="pl-8 pr-4">
                        <div className="grid grid-cols-1 md:grid-cols-2">
                            {value.content.map((item, i) => {
                                const total = value.content.length;
                                const isLastRow =
                                    total % 2 === 0
                                        ? i >= total - 2 
                                        : i === total - 1;

                                return (
                                    <div
                                        key={i}
                                        className={`grid grid-cols-2 py-2 items-center ${
                                            isLastRow ? "" : "border-b-2 border-slate-200"
                                        }`}
                                    >
                                        <span className="font-medium md:ml-20">
                                            {item.rubroName}
                                        </span>

                                        <span
                                            className={`text-gray-800 text-center ${
                                                item.unitType === "text" ? "" : "font-bold"
                                            }`}
                                        >
                                            {item.value ?? "N/A"} {item.unit ?? ""}
                                        </span>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </li>
            ))}
        </ul>
    );

}
